module.exports = __webpack_public_path__ + "static/media/home.dcf33201.png";